// js/tradeControlCalculator.js
// Calculadora de Posición para Trade Control

class TradeControlCalculator {
    constructor() {
        this.config = this.loadConfig();
        this.result = null;
    }

    /**
     * Carga configuración guardada
     */
    loadConfig() {
        try {
            const accountId = window.currentAccount;
            const key = `TC_CALCULATOR_${accountId}`;
            const stored = localStorage.getItem(key);
            
            if (stored) {
                return JSON.parse(stored);
            }
        } catch (e) {

        }

        // Valores por defecto
        return {
            balance: 10000,
            riskPercent: 1.0,
            pair: 'EURUSD',
            entry: '',
            stopLoss: ''
        };
    }

    /**
     * Guarda configuración
     */
    saveConfig() {
        try {
            const accountId = window.currentAccount;
            const key = `TC_CALCULATOR_${accountId}`;
            localStorage.setItem(key, JSON.stringify(this.config));
        } catch (e) {

        }
    }

    /**
     * Renderiza la calculadora en un contenedor
     */
    render(containerId) {
        const container = document.getElementById(containerId);
        if (!container) return;

        // Obtener riesgo sugerido del sistema
        const suggestedRisk = this.getSuggestedRisk();

        container.innerHTML = `
            <div class="position-calculator">
                <div class="calc-inputs">
                    <div class="calc-row">
                        <label for="calc_balance">
                            <span>Balance</span>
                            <button class="calc-sync-btn" onclick="window.tradeControlCalculator.syncBalance()" title="Sincronizar con cuenta actual">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 4v6h6M23 20v-6h-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                        </label>
                        <input 
                            type="number" 
                            id="calc_balance" 
                            value="${this.config.balance}" 
                            step="100"
                            onchange="window.tradeControlCalculator.updateField('balance', this.value)"
                        >
                    </div>

                    <div class="calc-row">
                        <label for="calc_risk">
                            <span>Riesgo %</span>
                            <span class="calc-hint">Sugerido: ${suggestedRisk}%</span>
                        </label>
                        <input 
                            type="number" 
                            id="calc_risk" 
                            value="${this.config.riskPercent}" 
                            step="0.1"
                            min="0.1"
                            max="5"
                            onchange="window.tradeControlCalculator.updateField('riskPercent', this.value)"
                        >
                    </div>

                    <div class="calc-row">
                        <label for="calc_pair">Par</label>
                        <select 
                            id="calc_pair"
                            class="max-h-48 overflow-y-auto scrollbar-thin scrollbar-thumb-cyan-500/50 scrollbar-track-slate-700/30 hover:scrollbar-thumb-cyan-400/70"
                            onchange="window.tradeControlCalculator.updateField('pair', this.value)"
                        >
                            ${this.renderPairOptions()}
                        </select>
                    </div>

                    <div class="calc-row">
                        <label for="calc_entry">Entry Price</label>
                        <input 
                            type="number" 
                            id="calc_entry" 
                            value="${this.config.entry}" 
                            step="0.00001"
                            placeholder="1.09500"
                            onchange="window.tradeControlCalculator.updateField('entry', this.value)"
                        >
                    </div>

                    <div class="calc-row">
                        <label for="calc_sl">Stop Loss</label>
                        <input 
                            type="number" 
                            id="calc_sl" 
                            value="${this.config.stopLoss}" 
                            step="0.00001"
                            placeholder="1.09000"
                            onchange="window.tradeControlCalculator.updateField('stopLoss', this.value)"
                        >
                    </div>

                    <div class="calc-row full-width">
                        <button class="calc-calculate-btn" onclick="window.tradeControlCalculator.calculate()">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2"/>
                                <path d="M3 9h18M9 21V9" stroke="currentColor" stroke-width="2"/>
                            </svg>
                            Calcular Posición
                        </button>
                    </div>
                </div>

                <div id="calcResult" class="calc-result ${this.result ? '' : 'hidden'}">
                    ${this.result ? this.renderResult() : ''}
                </div>
            </div>
        `;
    }

    /**
     * Renderiza opciones de pares
     */
    renderPairOptions() {
        const pairs = [
            // Forex Majors
            'EURUSD', 'GBPUSD', 'USDJPY', 'USDCHF', 'AUDUSD', 'USDCAD', 'NZDUSD',
            // Forex Crosses
            'EURJPY', 'GBPJPY', 'EURGBP', 'AUDJPY', 'EURAUD', 'EURCHF', 'AUDNZD',
            'NZDJPY', 'GBPAUD', 'GBPCAD', 'EURNZD', 'AUDCAD', 'GBPCHF', 'AUDCHF',
            'EURCAD', 'CADJPY', 'GBPNZD', 'CADCHF', 'CHFJPY', 'NZDCAD', 'NZDCHF',
            // Índices
            'US30', 'NAS100', 'SPX500', 'US500', 'US2000', 'DAX40', 'GER40', 'UK100',
            'FRA40', 'ESP35', 'ITA40', 'JPN225', 'HKG50', 'AUS200', 'VIX',
            // Metales
            'XAUUSD', 'XAGUSD', 'XPTUSD', 'XPDUSD', 'GOLD', 'SILVER',
            // Commodities
            'USOIL', 'UKOIL', 'XTIUSD', 'XBRUSD', 'NATGAS', 'NGAS',
            // Crypto
            'BTCUSD', 'ETHUSD', 'XRPUSD', 'LTCUSD', 'ADAUSD', 'SOLUSD', 'DOTUSD',
            'DOGEUSD', 'BNBUSD', 'AVAXUSD', 'MATICUSD', 'LINKUSD'
        ];

        return pairs.map(pair => 
            `<option value="${pair}" ${pair === this.config.pair ? 'selected' : ''}>${pair}</option>`
        ).join('');
    }

    /**
     * Actualiza un campo
     */
    updateField(field, value) {
        this.config[field] = field === 'pair' ? value : parseFloat(value) || this.config[field];
        this.saveConfig();
        
        // Si hay entry y SL, calcular automáticamente
        if (field === 'entry' || field === 'stopLoss') {
            if (this.config.entry && this.config.stopLoss) {
                this.calculate();
            }
        }
    }

    /**
     * Sincroniza balance con cuenta actual
     */
    syncBalance() {
        try {
            const accountId = window.currentAccount;
            
            // Obtener balance del Balance State Manager (fuente de verdad)
            let balance = 10000;
            
            if (window.balanceStateManager) {
                balance = window.balanceStateManager.getAccountBalance(accountId);
            } else if (window.accounts && window.accounts[accountId]) {
                balance = parseFloat(window.accounts[accountId].balance) || 10000;
            }
            
            this.config.balance = balance;
            this.saveConfig();
            
            // Actualizar input
            const input = document.getElementById('calc_balance');
            if (input) input.value = balance.toFixed(2);
            
            // Recalcular si hay datos
            if (this.result) {
                this.calculate();
            }
            
            this.showToast('Balance sincronizado: $' + balance.toFixed(2), 'success');
        } catch (e) {

            this.showToast('Error al sincronizar balance', 'error');
        }
    }

    /**
     * Obtiene el riesgo sugerido por el sistema
     */
    getSuggestedRisk() {
        try {
            // Intenta obtener del sistema de riesgo de Trade Control
            if (window.tradeControl) {
                return window.tradeControl.getCurrentRisk() || 1.0;
            }
        } catch (e) {

        }
        return 1.0;
    }

    /**
     * Calcula la posición
     */
    calculate() {
        const { balance, riskPercent, pair, entry, stopLoss } = this.config;

        // Validaciones
        if (!entry || !stopLoss) {
            this.showToast('⚠️ Ingresa Entry y Stop Loss', 'warning');
            return;
        }

        if (entry === stopLoss) {
            this.showToast('⚠️ Entry y Stop Loss no pueden ser iguales', 'warning');
            return;
        }

        try {
            // Determinar pip value según par
            const pipValue = this.getPipValue(pair);
            
            // Calcular distancia en pips
            const distance = Math.abs(entry - stopLoss);
            const pips = distance / pipValue;
            
            // Calcular riesgo en dólares
            const riskAmount = balance * (riskPercent / 100);
            
            // Calcular lotes
            // Fórmula: Lotes = Riesgo $ / (Pips × Valor por Pip × Lote Estándar)
            // Para forex: 1 lote estándar = 100,000 unidades
            // Valor por pip por lote estándar varía según par
            const pipValuePerLot = this.getPipValuePerLot(pair);
            const lots = riskAmount / (pips * pipValuePerLot);
            
            // Calcular take profit sugerido (Risk:Reward 1:2)
            const tpDistance = distance * 2;
            const takeProfit = entry > stopLoss ? entry + tpDistance : entry - tpDistance;
            
            // Validar lotes
            const isValid = lots > 0.01 && lots <= 10;

            this.result = {
                lots: lots.toFixed(2),
                pips: pips.toFixed(1),
                riskAmount: riskAmount.toFixed(2),
                distance: distance.toFixed(5),
                takeProfit: takeProfit.toFixed(5),
                potentialProfit: (riskAmount * 2).toFixed(2),
                riskReward: '1:2',
                isValid,
                warnings: this.getWarnings(lots, pips, riskPercent)
            };

            // Re-render resultado
            const resultContainer = document.getElementById('calcResult');
            if (resultContainer) {
                resultContainer.className = 'calc-result';
                resultContainer.innerHTML = this.renderResult();
            }

        } catch (e) {

            this.showToast('❌ Error en cálculo', 'error');
        }
    }

    /**
     * Obtiene el valor de pip según el par
     */
    getPipValue(pair) {
        // Pares con JPY usan 0.01 como pip
        if (pair.includes('JPY')) {
            return 0.01;
        }
        // Resto de pares usan 0.0001
        return 0.0001;
    }

    /**
     * Obtiene el valor por pip por lote estándar
     */
    getPipValuePerLot(pair) {
        // Simplificación: Para mayoría de pares, 1 pip = $10 por lote estándar
        // En un sistema real, esto debería calcularse dinámicamente con tasas de cambio
        if (pair.includes('JPY')) {
            return 10; // Para pares XXX/JPY
        }
        
        if (pair.startsWith('USD')) {
            return 10; // Para USD/XXX
        }
        
        // Para otros pares (EUR/USD, GBP/USD, etc.)
        return 10;
    }

    /**
     * Genera advertencias
     */
    getWarnings(lots, pips, riskPercent) {
        const warnings = [];

        if (lots > 5) {
            warnings.push('⚠️ Lotes muy altos - Considera reducir riesgo');
        }

        if (lots < 0.01) {
            warnings.push('⚠️ Lotes muy bajos - Verifica balance y riesgo');
        }

        if (pips < 10) {
            warnings.push('⚠️ Stop Loss muy ajustado (< 10 pips)');
        }

        if (pips > 100) {
            warnings.push('⚠️ Stop Loss muy amplio (> 100 pips)');
        }

        if (riskPercent > 2) {
            warnings.push('⚠️ Riesgo elevado - Considera reducir');
        }

        return warnings;
    }

    /**
     * Renderiza el resultado
     */
    renderResult() {
        if (!this.result) return '';

        const { lots, pips, riskAmount, distance, takeProfit, potentialProfit, riskReward, isValid, warnings } = this.result;

        return `
            <div class="result-header">
                <h4>📊 Resultado del Cálculo</h4>
                ${!isValid ? '<span class="result-invalid">⚠️ Valores fuera de rango</span>' : ''}
            </div>

            <div class="result-grid">
                <div class="result-item">
                    <span class="result-label">Distancia</span>
                    <strong class="result-value">${pips} pips</strong>
                    <small>${distance}</small>
                </div>

                <div class="result-item">
                    <span class="result-label">Riesgo en $</span>
                    <strong class="result-value risk-amount">$${riskAmount}</strong>
                </div>

                <div class="result-item highlight">
                    <span class="result-label">🎯 Lotes Sugeridos</span>
                    <strong class="result-value lots-value">${lots}</strong>
                </div>

                <div class="result-item">
                    <span class="result-label">Take Profit</span>
                    <strong class="result-value tp-value">${takeProfit}</strong>
                    <small>R:R ${riskReward}</small>
                </div>

                <div class="result-item">
                    <span class="result-label">Potencial Ganancia</span>
                    <strong class="result-value profit-value">$${potentialProfit}</strong>
                </div>
            </div>

            ${warnings.length > 0 ? `
                <div class="result-warnings">
                    ${warnings.map(w => `<div class="warning-item">${w}</div>`).join('')}
                </div>
            ` : ''}

            <div class="result-actions">
                <button class="result-copy-btn" onclick="window.tradeControlCalculator.copyToClipboard()">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="9" y="9" width="13" height="13" rx="2" stroke="currentColor" stroke-width="2"/>
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke="currentColor" stroke-width="2"/>
                    </svg>
                    Copiar Configuración
                </button>
            </div>
        `;
    }

    /**
     * Copia resultado al portapapeles
     */
    copyToClipboard() {
        if (!this.result) return;

        const { lots, pips, riskAmount, takeProfit, potentialProfit } = this.result;
        const { pair, entry, stopLoss, riskPercent } = this.config;

        const text = `
📊 Trade Setup - ${pair}
━━━━━━━━━━━━━━━━━━━━
Entry: ${entry}
Stop Loss: ${stopLoss}
Take Profit: ${takeProfit}
━━━━━━━━━━━━━━━━━━━━
💰 Lotes: ${lots}
📏 Distancia: ${pips} pips
💸 Riesgo: $${riskAmount} (${riskPercent}%)
🎯 Potencial: $${potentialProfit}
━━━━━━━━━━━━━━━━━━━━
Generated by Trade Control
        `.trim();

        navigator.clipboard.writeText(text).then(() => {
            this.showToast('✅ Configuración copiada al portapapeles', 'success');
        }).catch(e => {

            this.showToast('❌ Error al copiar', 'error');
        });
    }

    /**
     * Toast notification
     */
    showToast(message, type = 'info') {
        // Si existe tradeControlUI, usar su método
        if (window.tradeControlUI) {
            window.tradeControlUI.showToast(message, type);
        } else if (window.showNotification) {
            // Usar sistema moderno de notificaciones
            window.showNotification(message, type, 3000);
        } else {
            // Fallback simple

        }
    }
}

// Inicializar globalmente
if (typeof window !== 'undefined') {
    window.tradeControlCalculator = new TradeControlCalculator();
}
